import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../api/api';

export const orderApi = createApi({
  reducerPath: 'orderApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Order'],
  endpoints: (builder) => ({
    getOrders: builder.query({
      query: (page = 1) => ({
        url: 'api/web/v1/site/purchase',
        method: 'GET',
        params: { page },
        tokenType: 'admin',
      }),
      providesTags: ['Order'],
    }),
    viewOrder: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/view-order-merchant',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
    }),
    changeOrderStatus: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/change-status',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
      invalidatesTags: ['Order'],
    }),
  }),
});

export const {
  useGetOrdersQuery,
  useViewOrderMutation,
  useChangeOrderStatusMutation,
} = orderApi;
